import React from 'react';
import { inject, observer } from 'mobx-react';
import { roundToLocaleString } from '../../../../../../../../../../shared';
import { StyledText, StyledWrapper } from './styled';

const Cashback = inject('store')(
    observer(({ store }) => {
        return (
            <StyledWrapper>
                <StyledText type='body2' color='primary'>
                    Cash back
                </StyledText>
                <StyledText type='body2' color='primary'>
                    ${roundToLocaleString(store.cart.cashback, 2)}
                </StyledText>
            </StyledWrapper>
        );
    })
);

export default Cashback;
